export const ModalMixin = {
    computed: {
        modalVisible: {
            get() {
                return this.$store.state.modals[this.modalName];
            },
            set(value) {
                this.$store.commit(
                    "modal" + this.modalName.charAt(0).toUpperCase() + this.modalName.slice(1),
                    value
                );
            }
        }
    }
};
